import React, { useCallback, useEffect, useState } from "react";
import {
  SettingsAutocomplete,
  SettingsAutoCompleteOption,
} from "./settingsAutocomplete";
import { SearchOptions } from "../../../autocomplete";
import { useDaoContext } from "../../../diseaseview/DaoContext";
//region [[ Styles ]]

//endregion [[ Styles ]]

//region [[ Props ]]

export interface FeatureSelectorProps {
  onSelect: (value: any) => void;
  value: string;
  disableAutoFocus?: boolean;
  disabled?: boolean;
  searchOptions?: SearchOptions;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const FeatureSelector = ({
  searchOptions,
  ...props
}: FeatureSelectorProps) => {
  const [featureList, setFeatureList] = useState<SettingsAutoCompleteOption[]>(
    null,
  );
  const [term, setTerm] = useState("");
  const [value, setValue] = useState<SettingsAutoCompleteOption>(null);
  const [loading, setLoading] = useState(false);
  const loaded = React.useRef(false);
  const dao = useDaoContext();

  const handleTermChange = (event: object, value: string, reason: string) => {
    if (reason === "input") {
      setTerm(value);
    }
  };

  const handleSelect = (newValue: SettingsAutoCompleteOption | string) => {
    setValue(
      typeof newValue === "object"
        ? newValue
        : {
            value: newValue,
            name: newValue,
          },
    );
    props.onSelect(typeof newValue === "object" ? newValue?.value : newValue);
  };

  const getFeatureById = useCallback(
    async (id: string): Promise<SettingsAutoCompleteOption> => {
      return await dao.getFeatureById(id).then((f) => {
        return f
          ? {
              name: f.name,
              value: f.id,
            }
          : {
              name: id,
              value: id,
            }; //return id for both nane and value if feature not found - this is a workaround for when the feature list in the model is not latest
      });
    },
    [dao],
  );

  const searchFeature = useCallback(
    async (searchTerm: string): Promise<SettingsAutoCompleteOption[]> => {
      setLoading(true);
      const data = await dao
        .searchQualifiedFeatures(
          searchTerm,
          searchOptions.categories || [],
          searchOptions.gender,
          searchOptions.patientFacing,
          searchOptions.panelIds,
          searchOptions.ancestorsIds,
        )
        .then((response) =>
          response.map((qf) => ({ name: qf.name, value: qf.id })),
        )
        .catch((e) => {
          throw e;
        });
      setLoading(false);
      return data;
    },
    [dao],
  );

  useEffect(() => {
    const featureId = props.value;
    //initial load
    if (featureId) {
      getFeatureById(featureId)
        .then((result) => {
          setFeatureList([result]);
          setValue(result);
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      loaded.current = true;
    }
  }, [props.value, getFeatureById]);

  useEffect(() => {
    let active = true;

    if (term) {
      searchFeature(term)
        .then((newFeatureList) => {
          if (active) {
            setFeatureList(value ? [value, ...newFeatureList] : newFeatureList);
          }
        })
        .catch((e) => console.error(e.error));
    }

    return () => {
      active = false;
    };
  }, [term, searchFeature]);

  return (
    <SettingsAutocomplete
      onChange={(selValue) => handleSelect(selValue)}
      onInputChange={handleTermChange}
      value={value}
      loading={loading}
      options={featureList || []}
      autoFocus={!props.disableAutoFocus}
      disabled={props.disabled}
      minwidth={220}
      freeSolo={true}
    />
    // <AkFeatureSelection
    //   placeholder={"Search for feature"}
    //   searchOptions={{ categories: [] }}
    //   term={term}
    //   onTermChanged={handleTermChange}
    //   //hideResults={true}
    // />
  );
};
